import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useEffect, useRef, useState, } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import dayjs from 'dayjs';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [customerServiceOperator, setCustomerServiceOperator] = useState<any>();
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');

    useEffect(() => {
        let currentService = '';
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentService = ref.current.defaultService;
            setDefaultService(currentService);
        }
        const fetchData = async () => {
            fetchApi.GET(currentService, {
                apiId: "customerServiceOperator",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setCustomerServiceOperator(res.data);
                }
            })
        };
        fetchData();
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'emailSupplier',
        serviceId: 'business'
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '邮件供应商'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                // onKeyPress={(e: any) => {
                //     if (e.key === 'Enter') {
                //         handleOk(e)
                //     }
                // }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id"
                                tooltip='不输入id可生成随机id'>
                                <Input disabled={data.type === 'NEW' ? false : true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="名称"
                                name="supplierName"
                                rules={[{ required: true, message: '名称!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="SMTP服务器地址"
                                name="smtpHost"
                                tooltip='发送邮件SMTP服务器地址'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="SMTP端口号"
                                name="smtpPort"
                                tooltip='发送邮件SMTP服务器端口号'>
                                <Input />
                            </Form.Item>
                        </Col>


                        <Col span={12}>
                            <Form.Item
                                label="IMAP服务器地址"
                                name="imapHost"
                                tooltip='接收邮件IMAP服务器地址'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="IMAP端口号"
                                name="imapPort"
                                tooltip='接收邮件IMAP服务器端口号'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="账号/用户名"
                                name="loginAccount"
                                tooltip='登录的账号/用户名'
                                rules={[{ required: true, message: '账号/用户名' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="密码/授权码"
                                name="loginPassword"
                                tooltip='登录的密码/授权码'
                                rules={[{ required: true, message: '密码/授权码' }]}>
                                <Input.Password />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="邮件地址"
                                name="emailAddress"
                                tooltip='邮件地址，例如：xx@qq.com'
                                rules={[{ required: true, message: '邮件地址' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="昵称"
                                name="nickname"
                                tooltip='邮件显示的名称'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="安全加密"
                                name="isSecure"
                                tooltip='开启数据传输加密协议'
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebEdit;